/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index stat to autogenerate all the components and extensions
 * Used by "prepareStats"
 */

import Stat from './stat/Stat'
export * from './stat/Stat'
export default Stat
